module.exports = __webpack_public_path__ + "img/worn_forbidden.c40a7b0c.png";